import Vue from 'vue';
import Vuex from 'vuex';
import * as types from './mutation-types';

const storeModules = {};

function importAll(r) {
  r.keys()
    .forEach((key) => {
      const moduleName = key.match(/([\w-._\d]*?)\.js$/)[1];
      storeModules[moduleName] = r(key).default;
    });
}

importAll(require.context('./modules/', true, /\.js$/));

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: storeModules,
  strict: true,
  actions: {
    resetAll({ commit, getters }) {
      if (getters.getClues.length) {
        commit(types.CLEARED_CLUES);
      }
      if (getters.getQuestions.length) {
        commit(types.CLEARED_QUESTIONS);
      }
    },
  },
});
